import {
  FiPhone, FiMail, FiMapPin, FiClock, FiShield, FiUsers, FiFacebook, FiInstagram,
} from 'react-icons/fi';

const offices = [
  {
    label: 'Head Office',
    city: 'Morogoro',
    address: 'P.O. Box 1973, Near Station Road',
    phones: ['+255 762 764 651', '+255 792 622 100'],
    email: 'info@kikisecurity.com',
  },
  {
    label: 'Branch Office',
    city: 'Dar es Salaam',
    address: 'P.O. Box 61800, Nearby BAKITA Offices',
    phones: ['+255 552 222 117', '+255 792 222 170'],
    email: 'kiki.tz@outlook.com',
  },
];

const socialLinks = [
  {
    href: 'https://www.instagram.com/kikisecuritytz',
    label: 'Instagram',
    Icon: FiInstagram,
  },
  {
    href: 'https://www.facebook.com/share/1Hfxb1dpEG/?mibextid=wwXIfr',
    label: 'Facebook',
    Icon: FiFacebook,
  },
];

export default function Contact() {
  return (
    <div className="animate-fadeUp">

      {/* ── HERO ── */}
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-navy-DEFAULT via-navy-mid to-navy-light" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(201,168,76,0.10),transparent_60%)]" />
        <div className="relative max-w-7xl mx-auto px-6">
          <span className="section-tag">Contact Us</span>
          <h1 className="section-title mt-2 mb-4">
            Get in <span className="text-gold">Touch</span>
          </h1>
          <div className="gold-divider" />
          <p className="text-gray-300 text-lg max-w-2xl leading-relaxed">
            Ready to secure your business or need more information? Reach the right office directly
            for quotations, support, and site assessment bookings.
          </p>
        </div>
        <div className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-t from-navy-DEFAULT to-transparent" />
      </section>

      {/* ── MAIN CONTENT ── */}
      <section className="py-20 max-w-7xl mx-auto px-6">
        <div className="space-y-10">
          <div className="grid lg:grid-cols-3 gap-6">
            {offices.map(o => (
              <div
                key={o.label}
                className="rounded-[28px] bg-navy-card p-7 shadow-[0_18px_45px_rgba(0,0,0,0.22)] transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start justify-between gap-4 mb-6">
                  <div>
                    <p className="text-gold text-xs font-semibold uppercase tracking-[0.24em] mb-2">{o.label}</p>
                    <h3 className="text-white font-display text-2xl font-bold">{o.city}</h3>
                  </div>
                  <div className="w-11 h-11 rounded-2xl bg-gold/10 flex items-center justify-center">
                    <FiMapPin className="text-gold" size={18} />
                  </div>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-6">{o.address}</p>
                <div className="space-y-3">
                  {o.phones.map(p => (
                    <a
                      key={p}
                      href={`tel:${p.replace(/\s/g, '')}`}
                      className="flex items-center gap-3 text-gray-300 hover:text-gold transition-colors text-sm"
                    >
                      <FiPhone size={15} className="text-gold/70 flex-shrink-0" />
                      <span>{p}</span>
                    </a>
                  ))}
                  <a
                    href={`mailto:${o.email}`}
                    className="flex items-center gap-3 text-gray-300 hover:text-gold transition-colors text-sm"
                  >
                    <FiMail size={15} className="text-gold/70 flex-shrink-0" />
                    <span>{o.email}</span>
                  </a>
                </div>
              </div>
            ))}

            <div className="rounded-[28px] bg-gradient-to-br from-gold/12 via-gold/5 to-transparent p-7 shadow-[0_18px_45px_rgba(0,0,0,0.22)]">
              <p className="text-gold text-xs font-semibold uppercase tracking-[0.24em] mb-2">Support Desk</p>
              <h3 className="text-white font-display text-2xl font-bold mb-4">When To Reach Us</h3>
              <p className="text-gray-300 text-sm leading-relaxed mb-6">
                Contact our team during business hours for consultations and quotations. Emergency response remains available at all times.
              </p>
              <div className="space-y-4">
                {[
                  ['Monday - Friday', '8:00 AM - 6:00 PM'],
                  ['Saturday', '8:00 AM - 2:00 PM'],
                  ['Emergency Line', '24 / 7'],
                ].map(([day, time]) => (
                  <div key={day} className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-xl bg-navy-card/80 flex items-center justify-center flex-shrink-0">
                      <FiClock className="text-gold" size={15} />
                    </div>
                    <div>
                      <div className="text-white text-sm font-medium">{day}</div>
                      <div className="text-gray-400 text-sm">{time}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-[1.35fr_0.65fr] gap-6">
            <div className="rounded-[32px] bg-navy-card p-8 md:p-10 shadow-[0_22px_55px_rgba(0,0,0,0.25)]">
              <span className="section-tag">Direct Contact</span>
              <h2 className="section-title mt-2 mb-4">
                All the details you need to <span className="text-gold">reach KIKI Security</span>
              </h2>
              <div className="gold-divider" />
              <p className="text-gray-400 leading-relaxed max-w-3xl mb-8">
                For guarding services, CCTV projects, electric fence installation, recruitment, labour supply,
                or customer service staffing, contact the nearest office using the numbers and email addresses above.
              </p>

              <div className="grid md:grid-cols-2 gap-5">
                {[
                  {
                    Icon: FiShield,
                    title: 'Security & Technology',
                    text: 'Request site assessments, guarding deployments, CCTV installation, gate automation, and electric fence support.',
                  },
                  {
                    Icon: FiUsers,
                    title: 'Manpower & Staffing',
                    text: 'Reach out for recruitment, casual labour, skilled labour, and customer service agent placements.',
                  },
                ].map(({ Icon, title, text }) => (
                  <div key={title} className="rounded-2xl bg-navy-mid/70 p-6">
                    <div className="w-11 h-11 rounded-2xl bg-gold/10 flex items-center justify-center mb-4">
                      <Icon className="text-gold" size={18} />
                    </div>
                    <h3 className="text-white font-semibold text-lg mb-2">{title}</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">{text}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-[32px] bg-navy-mid p-8 shadow-[0_22px_55px_rgba(0,0,0,0.22)]">
              <p className="text-gold text-xs font-semibold uppercase tracking-[0.24em] mb-3">Need A Quote?</p>
              <h3 className="text-white font-display text-2xl font-bold mb-4">Call or email us directly</h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                Share your site location, service needed, and expected timeline. Our team will guide you on the next step.
              </p>
              <div className="space-y-4">
                <a href="tel:+255552222117" className="block rounded-2xl bg-navy-card px-5 py-4 text-gray-300 hover:text-gold transition-colors">
                  <span className="block text-xs uppercase tracking-[0.2em] text-gold/70 mb-1">Primary Line</span>
                  +255 552 222 117
                </a>
                <a href="mailto:info@kikisecurity.com" className="block rounded-2xl bg-navy-card px-5 py-4 text-gray-300 hover:text-gold transition-colors">
                  <span className="block text-xs uppercase tracking-[0.2em] text-gold/70 mb-1">Email</span>
                  info@kikisecurity.com
                </a>
                <div className="rounded-2xl bg-navy-card px-5 py-4">
                  <span className="block text-xs uppercase tracking-[0.2em] text-gold/70 mb-3">Social Media</span>
                  <div className="flex gap-3">
                    {socialLinks.map(({ href, label, Icon }) => (
                      <a
                        key={label}
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={label}
                        className="w-11 h-11 rounded-full bg-white/5 flex items-center justify-center text-gray-300 hover:text-gold transition-colors"
                      >
                        <Icon size={18} />
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
